import React, { memo } from 'react';

import './index.scss';

type LoaderProps = {
  blockInteraction?: boolean;
};

export const Loader = memo(function Loader({ blockInteraction = true }: LoaderProps) {
  return (
    <div className="small-loader-wrapper">
      <div className="small-loader" />
      {blockInteraction && <div className="small-loader-overlay" />}
    </div>
  );
}); 